import { Component, Input } from '@angular/core';
import {
  ChartDataSets,
  ChartOptions,
  ChartPluginsOptions,
  ChartType,
} from 'chart.js';
import { Label } from 'ng2-charts';

export interface ChartData {
  labels: string[];
  dataSets: ChartDataSets[];
}

const plugin = {
  beforeInit(chart: any) {
    // Get reference to the original fit function
    const originalFit = chart.legend.fit;
    // Override the fit function
    chart.legend.fit = function fit() {
      // Call original function and bind scope in order to use `this` correctly inside it
      originalFit.bind(chart.legend)();
      // Change the height as suggested in another answers
      this.height += 42;
    };
  },
};

@Component({
  selector: 'app-stacked-bars',
  templateUrl: './stacked-bars.component.html',
  styleUrls: ['./stacked-bars.component.scss'],
})
export class StackedBarsComponent {
  readonly maxBarThickness = 56;

  @Input() set data(value: ChartData) {
    this.barChartLabels = value.labels;
    this.barChartData = value.dataSets.map(data => ({
      ...data,
      maxBarThickness: this.maxBarThickness,
    }));
  }

  public barChartOptions: ChartOptions = {
    tooltips: {
      enabled: true,
      callbacks: {
        label: function (tooltipItem, data) {
          const value = data.datasets[tooltipItem.datasetIndex].data[
            tooltipItem.index
          ] as number;

          const label = data.datasets[tooltipItem.datasetIndex].label;

          const percentage = value.toFixed(2) + '%';
          return `${label}: ${percentage}`;
        },
      },
    },
    legend: {
      align: 'start',
      position: 'top',
      labels: {
        fontSize: 12,
        padding: 24,
        usePointStyle: true,
      },
    },
    responsive: true,
    scales: {
      xAxes: [
        {
          stacked: true,
          ticks: {
            stepSize: 25,
            max: 100,
            callback: function (value) {
              return value + '%';
            },
          },
        },
      ],
      yAxes: [
        {
          stacked: true,
        },
      ],
    },
  };

  barChartType: ChartType = 'horizontalBar';
  barChartLegend = true;

  barChartLabels: Label[] = [];
  barChartPlugins: ChartPluginsOptions[] = [plugin];
  barChartData: ChartDataSets[] = [];
}

